import { render, staticRenderFns } from "./MedicationReportInput.vue?vue&type=template&id=31065e40&scoped=true"
import script from "./MedicationReportInput.vue?vue&type=script&lang=js"
export * from "./MedicationReportInput.vue?vue&type=script&lang=js"
import style0 from "./MedicationReportInput.vue?vue&type=style&index=0&id=31065e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31065e40",
  null
  
)

export default component.exports